import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from "react-apollo";
import { createStore, applyMiddleware, compose } from 'redux';
import client from "./lib/apolloClient";
import reduxThunk from 'redux-thunk';
import reducers from './reducers';
import persistState from 'redux-localstorage';
import App from './components/App.js';
import { LOCAL_STORAGE_CONFIG } from './config';

const entries = require('object.entries');
const values = require('object.values');
require('classlist-polyfill');
require('./styles');


//////////////////////////////////////
// Entries, values shim for unsupported browsers
//////////////////////////////////////
if (!Object.entries) { entries.shim();}
if (!Object.values) { values.shim(); }


//IE11 - polyfill 
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, pos) {
            pos = !pos || pos < 0 ? 0 : +pos;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}
//////////////////////////////////////

//////////////////////////////////////
// Setup redux
//////////////////////////////////////
const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const enchancer = composeEnhancers(
  applyMiddleware(
    reduxThunk
  ),
  persistState(['forms'], LOCAL_STORAGE_CONFIG)
)

export const store = createStore(reducers, enchancer);
//////////////////////////////////////


//////////////////////////////////////
// Initialise App;
//////////////////////////////////////
ReactDOM.render(
  <ApolloProvider client={client}>
  <Provider store={store}>
      <App />
  </Provider>
  </ApolloProvider>,
document.getElementById('root')
);
//////////////////////////////////////



//////////////////////////////////////
// Util - check unneccessary re-renders
//////////////////////////////////////
// if (process.env.NODE_ENV !== 'production') {

//   const {whyDidYouUpdate} = require('why-did-you-update')
//   whyDidYouUpdate(React)

//   const { reactopt } = require('reactopt');
//   reactopt(React);
// }
/////////////////////////////////////